import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import _ from "lodash";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class NameComponent extends Component {
  render() {
    const { rowData } = this.props;
    const { defaultLocale } = this.props.metadata.customComponentMetadata;
    return <span>{rowData.pageTranslations[defaultLocale].name}</span>;
  }
}

class DateComponent extends Component {
  render() {
    const { rowData } = this.props;
    const { defaultLocale, data } = this.props.metadata.customComponentMetadata;
    return (
      <span>
        {moment(new Date(rowData.pageTranslations[defaultLocale][data])).format(
          "DD.MM.YYYY"
        )}
      </span>
    );
  }
}

class ActionComponent extends Component {
  openRemovePageTranslationModal = () => {
    const {
      openRemovePageTranslationModal
    } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    openRemovePageTranslationModal(row.uid);
  };

  openEditPageTranslationModal = () => {
    const {
      openEditPageTranslationModal
    } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    openEditPageTranslationModal(row.uid);
  };

  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.openEditPageTranslationModal}>edytuj</a>
              <br />
              <a onTouchTap={this.openRemovePageTranslationModal}>usuń</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired,
    pages: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onRowClick = (row, e) => {
    const { history, defaultLocale } = this.props;
    if (
      e.target.nodeName !== "INPUT" &&
      row.props.data.pageTranslations[defaultLocale].slug &&
      e.target.className !== "icon-table link" &&
      e.target.className !== "checkbox-in-table-label"
    ) {
      history.pushState(
        "/pages/:slug",
        `/pages/${row.props.data.pageTranslations[defaultLocale].slug}`,
        {}
      );
    }
  };

  removePageTranslation = () => {
    const {
      actions,
      notificationSystem,
      pageTranslations: { pageTranslations: { isRemoveModalVisible } },
      pages: { pages: { entities: pages, meta: pagesMeta } },
      defaultLocale
    } = this.props;
    actions
      .removePagesTranslation(
        pages.getIn([
          isRemoveModalVisible,
          "pageTranslations",
          defaultLocale,
          "uid"
        ])
      )
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          let notification = {
            level: "success",
            message: "Usunięto wpis!",
            position: "br",
            autoDismiss: 5,
            dismissible: true
          };
          notificationSystem.addNotification(notification);

          actions.getPages(pagesMeta).then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
        }
      });
    actions.setIsRemovePageTranslationModalVisible(false);
  };

  openRemovePageTranslationModal = uid => {
    const { actions } = this.props;
    actions.setIsRemovePageTranslationModalVisible(uid);
  };

  closeRemovePageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsRemovePageTranslationModalVisible(false);
  };

  updatePageTranslation = () => {
    const {
      pages: { pages: { meta: pagesMeta } },
      actions,
      notificationSystem,
      pageTranslations: {
        pageTranslations: { isEditModalVisible, entities: pageTranslations }
      },
      defaultLocale
    } = this.props;
    const data = {
      name: pageTranslations.getIn([isEditModalVisible, defaultLocale, "name"])
    };
    const uid = pageTranslations.getIn([
      isEditModalVisible,
      defaultLocale,
      "uid"
    ]);
    actions.updatePagesTranslation(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions.getPages(pagesMeta).then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
    actions.setIsEditPageTranslationModalVisible(false);
  };

  openEditPageTranslationModal = uid => {
    const { actions } = this.props;
    actions.setIsEditPageTranslationModalVisible(uid);
  };

  closeEditPageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsEditPageTranslationModalVisible(false);
  };

  render() {
    const {
      pages,
      pages: { pages: { meta: { currentPage, limit } } },
      pageTranslations: {
        pageTranslations: {
          isRemoveModalVisible,
          isEditModalVisible,
          loading,
          entities: pageTranslations
        }
      },
      actions,
      tableWidth,
      tableHeight,
      defaultLocale
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "createdAt",
        displayName: "Data dodania",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DateComponent,
        customComponentMetadata: {
          data: "createdAt",
          defaultLocale: defaultLocale
        }
      },
      {
        columnName: "updatedAt",
        displayName: "Data edycji",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DateComponent,
        customComponentMetadata: {
          data: "updatedAt",
          defaultLocale: defaultLocale
        }
      },
      {
        columnName: "name",
        displayName: "Nazwa strony",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: NameComponent,
        customComponentMetadata: {
          defaultLocale: defaultLocale
        }
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemovePageTranslationModal: this.openRemovePageTranslationModal,
          openEditPageTranslationModal: this.openEditPageTranslationModal
        }
      }
    ];

    let data = [];
    let index = 0;

    pages.getIn(["pages", "entities"]).forEach(function(page) {
      page = page.toJS();
      index++;
      page.index = index + currentPage * limit;
      data = data.concat(page);
    });

    const editPageTranslationProps = {
      actions: actions,
      entity: pages.getIn(["pages", "entities", isEditModalVisible]),
      feature: "pages",
      uid: isEditModalVisible
    };

    const inputCustomProps = {
      feature: "pageTranslations",
      actions: actions,
      entity: pageTranslations.get(isEditModalVisible),
      uid: isEditModalVisible
      // placeholder: field.get('placeholder')
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "name", "createdAt", "updatedAt", "actions"]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          noDataMessage={loading ? "" : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />

        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemovePageTranslationModal}
            enterAction={this.removePageTranslation}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Uwaga!</h3>
              <p>Czy na pewno usunąć?</p>
              <button className="error" onTouchTap={this.removePageTranslation}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeRemovePageTranslationModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditPageTranslationModal}
            enterAction={this.updatePageTranslation}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Edytuj tytuł wpisu</h3>
              <InputCustom
                field={[defaultLocale, "name"]}
                {...inputCustomProps}
              />
              <button className="error" onTouchTap={this.updatePageTranslation}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeEditPageTranslationModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pages/table.react.js